/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import html2canvas from 'html2canvas'
import {Camera} from 'phosphor-react'
import Swal from 'sweetalert2'
import axios from 'axios'
const API_URL = process.env.REACT_APP_API_URL || 'api'

const HelpDrawer = () => {
  const [screenshot, setScreenshot] = useState<string | null>(null)
  const [problema, setProblema] = useState(false)
  const [sugestao, setSugestao] = useState(false)
  const [outros, setOutros] = useState(false)
  const [comment, setComment] = useState('')
  const [show, setShow] = useState(true)
  const [suport_type, setMotivo] = useState('')
  const navigate = useNavigate()
  const [file, setFile] = useState<File | null>(null)

  //BUSCA TOKEN NO LOCALSTORAGE
  let token = localStorage.getItem('auth_storage')
  if (token) token = token.replace(/['"]+/g, '')

  function clearTela() {
    setScreenshot(null)
  }

  function resetAll() {
    setScreenshot(null)
    setProblema(false)
    setSugestao(false)
    setOutros(false)
    setComment('')
  }

  function handleBack() {
    setProblema(false)
    setSugestao(false)
    setOutros(false)
  }

  async function handleProblema() {
    setMotivo('problema')
    if (problema === true) {
      setProblema(false)
    } else {
      setProblema(true)
    }
  }

  async function handleSugestao() {
    setMotivo('Sugestao')
    if (sugestao === true) {
      setSugestao(false)
    } else {
      setSugestao(true)
    }
  }

  async function handleOutros() {
    setMotivo('Outros')
    if (outros === true) {
      setOutros(false)
    } else {
      setOutros(true)
    }
  }

  async function handleTakeScreenshot() {
    const canvas = await html2canvas(document.querySelector('html')!)
    const base64image = canvas.toDataURL('image/png')
    setScreenshot(base64image)

    const base64 = base64image.split(';base64,').pop()
    const blob = await fetch(`data:image/png;base64,${base64}`).then((res) => res.blob())
    const file = new File([blob], 'screenshot.png', {type: 'image/png'})
    setFile(file)
    // Agora você pode utilizar o objeto `file`
  }

  async function prinTela() {
    setShow(false)
    setTimeout(() => {
      handleTakeScreenshot()
    }, 5)

    setTimeout(() => {
      setShow(true)
    }, 10)
  }

  const datasend = new FormData()
  async function handleSubmitFeedback(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault()

    datasend.append('comment', comment)
    datasend.append('suport_type', suport_type)
    datasend.set('screenshot', file! as File)

    try {
      await axios({
        method: 'post',
        url: `${API_URL}/v1/feedback`,
        data: datasend,
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
          //   },
        },
      })
      Swal.fire({
        icon: 'success',
        title: 'Sua solicitação foi enviada com sucesso!',
        showConfirmButton: false,
        timer: 2000,
      })
      resetAll()
      navigate('/')
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Erro ao enviar sua solicitação!',
        showConfirmButton: false,
        timer: 2000,
      })
    }

    // onFeedbackSent()
  }

  return (
    <div
      id='kt_help'
      className='bg-light mh-600px min-h-400px align-content-center my-5 
      rounded-start border border-2
       border-dashed border-primary  shadow-5 '
      data-kt-drawer='true'
      data-kt-drawer-name='help'
      data-kt-drawer-activate='true'
      data-kt-drawer-overlay='false'
      data-kt-drawer-width="{default:'50px', 'md': 'auto'}"
      data-kt-drawer-placement='right'
      data-kt-drawer-direction='end'
      data-kt-drawer-toggle='#kt_help_toggle'
      data-kt-drawer-close='#kt_help_close'
    >
      {/* begin::Card */}
      {show && (
        <div className='bg-light card shadow-5 rounded-0 w-425px h-400px '>
          <div className='card-body' id='kt_help_body'>
            {/* begin::Content */}
            <div
              id='kt_help_scroll'
              className='hover-overlay-y'
              data-kt-scroll='false'
              data-kt-scroll-height='auto'
              data-kt-scroll-wrappers='#kt_help_body'
              data-kt-scroll-dependencies='#kt_help_header'
              data-kt-scroll-offset='5px'
            >
              {/* begin::Support */}
              <div className=''>
                {/* begin::Heading */}
                <h2 className='fw-bolder mb-2 mt-n4  text-center'>
                  {/* Suporte do{' '} */}
                  <a href='https:https://www.orbitgeo.com.br' className=''>
                    <img
                      alt='Logo Empresa'
                      src={toAbsoluteUrl('/media/logos/ambipar_response_black.png')}
                      className='h-50px w-auto mt-5 text-white mx-3 mb-3'
                    />
                  </a>

                  {/* BOTÃO FECHAR */}
                  <button
                    type='button'
                    className='btn btn-sm btn-icon explore-btn-dismiss justify-content-end'
                    id='kt_help_close'
                  >
                    <KTSVG
                      path='/media/icons/duotune/general/gen034.svg'
                      className='svg-icon-1 svg-icon-primary me-n5'
                    />
                  </button>
                </h2>

                {/* end::Heading */}

                {/* begin::Description */}

                <div className='fs-5 fw-bold mb-2 text-center'>
                  <span className='text-gray-900'>
                    <b>Como podemos ajudar?</b>
                  </span>
                  <br />

                  <span className='text-gray-600'>
                    Você pode cuidar rapidamente da maioria das coisas por aqui ou falar conosco
                    quando necessário.
                  </span>
                </div>

                {problema || sugestao || outros || (
                  <div
                    className='btn btn-lg explore-btn-primary w-100 mb-4'
                    onClick={handleProblema}
                  >
                    Problemas
                  </div>
                )}

                {/* begin::Link */}
                {problema || sugestao || outros || (
                  <div
                    className='btn btn-lg explore-btn-primary w-100 mb-4'
                    onClick={handleSugestao}
                  >
                    Sugestão
                  </div>
                )}
                {/* end::Link */}

                {/* begin::Link */}
                {problema || sugestao || outros || (
                  <div className='btn btn-lg explore-btn-primary w-100 mb-4' onClick={handleOutros}>
                    Outros
                  </div>
                )}
                {/* end::Link */}

                {(problema || sugestao || outros) && (
                  <div className=' border-dark'>
                    <form
                      onSubmit={handleSubmitFeedback}
                      className='my-2 bg-gray-200 py-0  mb-n5 px-5 shadow-1 border border-primary px-1 rounded-1'
                    >
                      <div className='form-group mb-2'>
                        <button
                          type='button'
                          className='btn btn-sm btn-icon explore-btn-dismiss me-5 '
                          onClick={handleBack}
                        >
                          <KTSVG
                            path='/media/icons/duotune/arrows/arr021.svg'
                            className='svg-icon-2 svg-icon-dark btn-outline '
                          />{' '}
                        </button>

                        <label htmlFor='comment' className='fs-5 fw-bold text-center'>
                          <b>Descreva o {suport_type}:</b>
                        </label>
                      </div>
                      <textarea
                        className='                                              
                         w-100                         
                         min-h-80px 
                         text-sm placeholder-zinc-400
                          text-zinc-100
                           border-zinc-600
                            bg-light
                             rounded-md
                           focus:outline-none
                            focus:border-brand-500 focus:ring-brand-500
                            focus:ring-1 resize-none  scrollbar-thin scrollbar-thumb-zinc-700
                            
                             rounded'
                        placeholder='  Conte com detalhes o que está acontecendo...'
                        onChange={(e) => setComment(e.target.value)}
                        value={comment}
                      ></textarea>

                      <footer className='flex gap-2 mt-2  align-items-center'>
                        {screenshot && (
                          <div className='flex-1 mx-10'>
                            <img
                              src={screenshot}
                              alt='Screenshot'
                              className='w-100
                           h-50 rounded border border-dark'
                            />
                          </div>
                        )}
                        <button onClick={prinTela} className='p-2  btn btn-info mx-1  my-4'>
                          <Camera className='mx-2' size={20}></Camera>
                          Print&nbsp;
                        </button>

                        {screenshot && (
                          <button onClick={clearTela} className='p-2 btn btn-danger mx-2 my-1'>
                            <KTSVG
                              path='/media/icons/duotune//general/gen027.svg'
                              className='svg-icon-2 mx-2 md-n1'
                            />
                            Excluir &nbsp;
                          </button>
                        )}
                        <button
                          type='submit'
                          // disabled={isSendButtonDisabled}
                          className='p-2  btn btn-primary mx-1'
                        >
                          {'Enviar'}
                        </button>
                      </footer>
                    </form>
                  </div>
                )}

                {/* end::Link */}
              </div>
              {/* end::Support */}
            </div>
            {/* end::Content */}
          </div>
          {/* end::Body */}
        </div>
      )}
      {/* end::Card */}
    </div>
  )
}

export {HelpDrawer}
